// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2-ixg","overflowing":"ReadFullNote_overflowing__3JEXu"};